import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/home/Section1.css'; // Updated import path

const Section1 = () => {
  return (
    <section className="hero-section">
      <div className="content-container">
        <h1 className="main-heading">We Go Where Others Don’t</h1>
        <p className="subtext">We’ve spent years building the rails, student by student, campus
          by campus, to give brands frictionless access to a notoriously hard-to-reach demographic.
          Our platform turns untapped potential into strategic advantage.</p>
        
        <div className="cta-container">
          <Link to="/brands"><button className="learn-more-btn">Learn More</button></Link>
        </div>
      </div>

      {/* Image placeholder container */}
      <div className="image-container">
        <div className="image-placeholder1"></div>
      </div>
    </section>
  );
};

export default Section1;